import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerCapability } from "../_types/worker-capability";
import { WorkerVehicle } from "../_types/worker-vehicle";
import { WorkerBillableItem } from "../_types/worker-billable-item";
import { WorkerSeizure } from "../_types/worker-seizure";

@Injectable({
    providedIn: 'root',
})
export class WorkerSeizuresService extends Service<WorkerSeizure> {
    public override type = 'workerSeizures';
    public override url = 'invoicing/workerSeizures';
}
